module.exports = __webpack_public_path__ + "static/media/pdfFileIcon.a029d8e5.svg";